import { factory, primaryKey, manyOf } from '@mswjs/data';

const dbModels = {
  user: {
    id: primaryKey(String),
    email: String,
    password: String,
    base_lead_id: String,
    role: String,
    practice_id: String,
    selected_profile: Boolean,
    enrolled_courses: manyOf('course'),
  },

  profile: {
    id: primaryKey(String),
    name: String,
    mobile_number: String,
    email: String,
    role: String,
    avatar: String,
    base_lead_id: String,
    practice_id: String,
    grade: String,
    absolute_grade: String,
    address: String,
    zipcode: String,
    city: String,
    state: String,
    country: String,
    payment_status: String,
    is_communication: Boolean,
    doubtgpt_enabled: Boolean,
    selected_variant_id: String,
    gender: String,
    first_registered: manyOf('first_registered'),
    enrolled_courses: manyOf('course'),
  },

  course: {
    course_id: primaryKey(String),
    course_name: String,
    created_at: String,
    status: String,
    batch_id: String,
    created_by: String,
    modified_by: String,
    eligible_for_send_cert: Boolean,
    product_id: String,
    modified_on: Number,
    current_credit: {
      bought_credit: Number,
      bhanzu_money_credit: Number,
      free_credit: Number,
    },
    expiry_date: Number,
    profile_id: String,
    variant_id: String,
    created_on: Number,
    category: String,
    credit_policy: String,
    allow_multiple_active: Boolean,
    invoice_link: String,
  },

  first_registered: {
    id: primaryKey(String),
    registered_timestamp: String,
    registered_timestamp_readable: String,
    source: String,
  },
};

export const db = factory(dbModels);

export type Model = keyof typeof dbModels;

export const loadDb = (): Record<string, any> => {
  const data = globalThis.localStorage?.getItem('msw-db') ?? '{}';
  return JSON.parse(data) as Record<string, any>;
};

export const saveDb = (data: Record<string, any>) => {
  const dataString = JSON.stringify(data);
  globalThis.localStorage?.setItem('msw-db', dataString);
};

export const persistDb = (model: Model) => {
  if (process.env.NODE_ENV === 'test') return;

  const data = loadDb();
  data[model] = db[model].getAll();
  saveDb(data);
};

export const initializeDb = () => {
  const database = loadDb();
  for (const [key, model] of Object.entries(db)) {
    const dataEntries = database[key] as Record<string, any>[] | undefined;
    if (dataEntries && Array.isArray(dataEntries)) {
      for (const entry of dataEntries) {
        model.create(entry);
      }
    }
  }
};
